import {TAKE_DESK} from './types';

interface Desks {
    //вынести в отдельный файл
    desk_id: number;
    deskName: string;
    deskModel: string;
    regNumber: string;
    serialNumber: string;
    shift: number;
    ofd: string;
    tradePlace: string;
}

interface desksState {
    desks: Desks[];
}

interface UserAction {
    type: string;
    payload?: any;
}

const initialState: desksState = {
    desks: [
        {
            desk_id: 1,
            deskName: 'ККМ Тест Терентий',
            deskModel: '100Ф',
            regNumber: '005500000430',
            serialNumber: '005500000430',
            shift: 7,
            ofd: 'ТТК',
            tradePlace: 'Проспект Тест Парковый 33',
        },
        {
            desk_id: 2,
            deskName: 'ККМ на шоссе МОДЕРН',
            deskModel: '100Ф',
            regNumber: '1111111111111',
            serialNumber: '1111111111111',
            shift: 8,
            ofd: 'ТТК',
            tradePlace: 'Проспект Тест Парковый 33',
        },
        {
            desk_id: 3,
            deskName: 'ККМ Тест УЛК',
            deskModel: '100Ф',
            regNumber: '222222222222',
            serialNumber: '222222222222',
            shift: 12,
            ofd: 'КазТрансКом',
            tradePlace: 'Шоссе ш. Космонавтов 105',
        },
    ],
};

const reducer = (state = initialState, action: UserAction) => {
    switch (action.type) {
        case TAKE_DESK:
            return {state, action: action.payload};

        default:
            return state;
    }
};

export {reducer};
